import React from 'react';
import { Card } from 'primereact/card';

import styles from './cardCompare.module.css';

export default function CardCompare(props){
    return(
        <div className="grid">
            {(props.viabilities || []).map(viability => (
                <div key={viability.key} className="col-6 lg:col-4 xl:col-4">
                    <Card title={viability.title}>
                        <div className="formgrid grid">
                            {viability.values.map(field => (
                                <div className="field col-12" key={viability.key + "_" + field.label}>
                                    <label>{field.label}</label>
                                    <span className={styles.value}>{field.value}</span>
                                </div>
                            ))}
                        </div>
                    </Card>
                </div>
            ))}
        </div>
    );
}